import { OffersExperienceResponse } from 'api/definitions/offers-experience';
import {
  OFFER_LOADED,
  OFFER_FAILED,
  OFFER_LOADING,
  TOGGLE_OFFER_EDITING,
} from 'redux/modules/missed-offer/actions/types';

import { deepFreeze } from 'utils/deepFreeze';

const initialState = deepFreeze({
  loading: false,
  offer: null,
  error: null,
  editing: false,
});

export default (
  state = initialState,
  action: { payload?: OffersExperienceResponse; type?: string } = {},
) => {
  const { payload, type } = action;

  switch (type) {
    case OFFER_LOADING:
      return {
        ...state,
        loading: true,
        offer: null,
        error: null,
        editing: true,
      };

    case OFFER_FAILED:
      return {
        ...state,
        offer: null,
        error: null,
        loading: false,
      };

    case OFFER_LOADED:
      return {
        ...state,
        offer: payload,
        loading: false,
        error: null,
      };

    case TOGGLE_OFFER_EDITING:
      return {
        ...state,
        editing: payload,
      };

    default:
      return state;
  }
};
